<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>Teacher List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('teachers.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Name</div>
                      <v-text-field
                        v-model="filters.name"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Name"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Gender</div>
                      <v-select
                        v-model="filters.gender"
                        :items="genderOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Gender"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Native Speaker?</div>
                      <v-select
                        v-model="filters.is_native_speaker"
                        :items="yesNoOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Yes / No"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Status</div>
                      <v-select
                        v-model="filters.status"
                        :items="statusOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Status"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Birth date</div>
                      <date-picker
                        v-model="filters.date_of_birth"
                        value-type="format"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Join date</div>
                      <date-picker
                        v-model="filters.join_date"
                        value-type="format"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Created At</div>
                      <date-picker
                        v-model="filters.created_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Updated At</div>
                      <date-picker
                        v-model="filters.updated_at"
                        value-type="format"
                        type="datetime"
                        range
                        confirm
                        class="mx-datepicker--dense"
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.name`]="{ item }">
            <v-badge
              v-if="item.is_native_speaker"
              content="Native"
              color="warning"
            >
              {{ item.name }}
            </v-badge>
            <div v-else>
              {{ item.name }}
            </div>
          </template>
          <template #[`item.gender`]="{ item }">
            {{ genderProps(item.gender, 'text') }}
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip
              :color="teacherStatusProps(item.status, 'color')"
              small
              dark
            >
              <strong>
                {{ teacherStatusProps(item.status, 'text') }}
              </strong>
            </v-chip>
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn
                small
                color="secondary"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('teachers.detail', item.id)"
              >
                <v-icon small>mdi-eye</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;View</span>
              </v-btn>
              <v-btn
                small
                color="warning"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('teachers.update', item.id)"
              >
                <v-icon small>mdi-pencil</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
              </v-btn>
              <!-- <v-btn
                small
                color="error"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showDeleteDialog(item)"
              >
                <v-icon small>mdi-delete-forever</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
              </v-btn> -->
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <teacher-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :teacher="deleteDialog.item"
      @delete="getListData"
    >
    </teacher-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import TeacherDeleteDialog from '@components/Teacher/DeleteDialog'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'Teacher',
  components: {
    TeacherDeleteDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Gender', value: 'gender', sortable: false },
        { text: 'Date of Birth', value: 'date_of_birth' },
        { text: 'Phone Number', value: 'phone_number', sortable: false },
        { text: 'Join Date', value: 'join_date' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      dobMenu: false,
      joinDateMenu: false,
      filters: {
        name: null,
        email: null,
        gender: null,
        status: null,
        is_native_speaker: null,
        date_of_birth: [],
        join_date: [],
        created_at: [],
        updated_at: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'teacher/list',
      isLoading: 'teacher/isListLoading',
      listParams: 'teacher/listParams',
    }),
    genderOptions() {
      return constant.genderOptions
    },
    statusOptions() {
      return constant.teacherStatusOptions
    },
    yesNoOptions() {
      return constant.yesNoOptions
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getItemList: 'teacher/getList',
    }),
    ...mapMutations({
      setListParams: 'teacher/setListParams',
    }),
    init() {
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
      }
    },
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
  },
}
</script>
